module.exports = __webpack_public_path__ + "components/flag/static/square/gb-eng-73c41c52122eb8080d7a79977831edf7.svg";